import { Component, OnDestroy, OnInit } from '@angular/core';
import { VersionService } from '../../_services/version.service';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { Subject, of } from 'rxjs';

@Component({
  selector: 'app-version',
  template: ``,
  styles: []
})
export class VersionComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(
    private versionService: VersionService
  ) { }

  ngOnInit() {
    this.getVersion();
  }

  getVersion() {
    this.versionService.getVersion()
    .pipe(
      takeUntil(this.destroy$),
      tap(data => {
        console.info(data);
        window.history.back();
      }),
      catchError(error => {
        console.error(error);
        window.history.back();
        return of([]);
      })
    )
    .subscribe()
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
